import YoutubePlay from '@elem/SVGIcon/OutdoorRecreation/YoutubePlay';
import classNames from 'classnames';
import EFPicture from 'elem/ui/ef-picture';
import React, { useEffect, useState } from 'react';
import { Scrollbar, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EfDialogYoutube from '../ef-dialog-youtube';
import gtm from '@/utils/gtm';
import './index.scss';

export interface EfStoryAuthorItemProps {
    /**
     * title
     */
    title: string;
    /**
     * youtube文本
     */
    text: string;
    /**
     * youtube视频链接
     */
    link: string;
    /**
     * 图片avatar
     */
    avatar: string;
    /**
     * imgPC
     */
    imgPC: string;
    /**
     * imgPad
     */
    imgPad?: string;
    /**
     * imgH5
     */
    imgH5?: string;
    /**
     * author
     */
    author: string;
}

interface EfUserStoriesYoutubeAuthorProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 段落标题
     */
    title: string;
    /**
     * 列表
     */
    lists: EfStoryAuthorItemProps[];
    /**
     * gtm title_name
     */
    gtm_title_name?: string;
    /**
     * gtm position
     */
    gtm_position?: string;
    /**
     * scrollbar
     */
    scrollbar?: boolean;
}

/**
 * 维护: fund
 *
 * 用户故事 - 带标题、描述、头像
 */
const EfUserStoriesYoutubeAuthor: React.FC<EfUserStoriesYoutubeAuthorProps> = ({ lists = [], title, className, scrollbar, gtm_title_name, gtm_position }) => {
    const prefixCls = `ef-user-stories-youtube-author`;
    const [gap, setGap] = useState(24);
    const [open, setOpen] = useState(false);
    const [youtubeSrc, setYoutubeSrc] = useState('');
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });
    const items = lists?.slice(0, 4);

    const handlePlay = (youtube: any) => {
        setYoutubeSrc(youtube?.link);
        setOpen(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: gtm_title_name || youtube.text,
            position: gtm_position || 'Product Sale',
        });
    };

    const handleClose = () => {
        setOpen(false);
        setYoutubeSrc('');
    };

    useEffect(() => {
        const resetGap = () => {
            const winW = window.innerWidth;
            if (winW >= 1440) {
                return setGap(24);
            } else if (winW > 1024) {
                return setGap(20);
            } else {
                return setGap(16);
            }
        };
        resetGap();
    }, []);

    return (
        <div className={classes}>
            <p className={`${prefixCls}-title`}>{title}</p>
            <Swiper
                className={`${prefixCls}-swiper-box ${scrollbar ? 'show-scroll-bar' : 'hide-scroll-bar'}`}
                navigation={lists?.length > 1}
                modules={[Scrollbar, Navigation]}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                scrollbar={
                    scrollbar
                        ? {
                              hide: false,
                              draggable: true,
                              dragSize: 32,
                              snapOnRelease: true,
                          }
                        : false
                }
            >
                {items.map((card: any, k: number) => (
                    <SwiperSlide className={`${prefixCls}-swiper-item ${prefixCls}-item-${k + 1}`} key={k}>
                        <div className={`${prefixCls}-card-img`} onClick={() => handlePlay(card)}>
                            <EFPicture src={card.imgPC} srcPad={card?.imgPad || card?.imgH5} srcMobile={card?.imgH5} alt={card.text} />
                            <p className={`${prefixCls}-card-title`}>{card.title}</p>
                            <YoutubePlay />
                        </div>
                        <div className={`${prefixCls}-card-info`}>
                            <EFPicture src={card.avatar} alt={card.text} />
                            <div className="text">
                                <p className={`${prefixCls}-card-text`}>{card.text}</p>
                                <p className={`${prefixCls}-card-author`}>{card.author}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <EfDialogYoutube src={youtubeSrc} open={open} callback={handleClose} />
        </div>
    );
};

export default EfUserStoriesYoutubeAuthor;
